// extracted by mini-css-extract-plugin
export default {"tooltip":"lL-z","arrow":"mL-z"};